/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateUserState} from '../models/UpdateUserState';
import type {UserStateUpdateResult} from '../models/UserStateUpdateResult';

export interface GetUserStatesBulkUpdateProgress$Request {
    id: string;
}

export interface GetUserStatesBulkUpdateProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserStatesBulkUpdateProgressRequest = createAction<PayloadData<void, GetUserStatesBulkUpdateProgress$Request>>('USER_STATE_BULK_UPDATE__GET_USER_STATES_BULK_UPDATE_PROGRESS__REQUEST');
export const getUserStatesBulkUpdateProgressSuccess = createAction<PayloadData<BulkProgress, GetUserStatesBulkUpdateProgress$Request>>('USER_STATE_BULK_UPDATE__GET_USER_STATES_BULK_UPDATE_PROGRESS__SUCCESS');
export const getUserStatesBulkUpdateProgressFailure = createAction<PayloadData<Error, GetUserStatesBulkUpdateProgress$Request, true>>('USER_STATE_BULK_UPDATE__GET_USER_STATES_BULK_UPDATE_PROGRESS__FAILURE');

export const getUserStatesBulkUpdateProgressActions = [
    getUserStatesBulkUpdateProgressRequest,
    getUserStatesBulkUpdateProgressSuccess,
    getUserStatesBulkUpdateProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserStatesBulkUpdateProgress = (meta: GetUserStatesBulkUpdateProgress$Request, config?: GetUserStatesBulkUpdateProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUserStatesBulkUpdateProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/states/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserStatesBulkUpdateResult$Request {
    id: string;
}

export interface GetUserStatesBulkUpdateResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserStatesBulkUpdateResultRequest = createAction<PayloadData<void, GetUserStatesBulkUpdateResult$Request>>('USER_STATE_BULK_UPDATE__GET_USER_STATES_BULK_UPDATE_RESULT__REQUEST');
export const getUserStatesBulkUpdateResultSuccess = createAction<PayloadData<UserStateUpdateResult, GetUserStatesBulkUpdateResult$Request>>('USER_STATE_BULK_UPDATE__GET_USER_STATES_BULK_UPDATE_RESULT__SUCCESS');
export const getUserStatesBulkUpdateResultFailure = createAction<PayloadData<Error, GetUserStatesBulkUpdateResult$Request, true>>('USER_STATE_BULK_UPDATE__GET_USER_STATES_BULK_UPDATE_RESULT__FAILURE');

export const getUserStatesBulkUpdateResultActions = [
    getUserStatesBulkUpdateResultRequest,
    getUserStatesBulkUpdateResultSuccess,
    getUserStatesBulkUpdateResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserStatesBulkUpdateResult = (meta: GetUserStatesBulkUpdateResult$Request, config?: GetUserStatesBulkUpdateResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUserStatesBulkUpdateResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/states`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopUserStatesBulkUpdate$Request {
    id: string;
}

export interface StopUserStatesBulkUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopUserStatesBulkUpdateRequest = createAction<PayloadData<void, StopUserStatesBulkUpdate$Request>>('USER_STATE_BULK_UPDATE__STOP_USER_STATES_BULK_UPDATE__REQUEST');
export const stopUserStatesBulkUpdateSuccess = createAction<PayloadData<void, StopUserStatesBulkUpdate$Request>>('USER_STATE_BULK_UPDATE__STOP_USER_STATES_BULK_UPDATE__SUCCESS');
export const stopUserStatesBulkUpdateFailure = createAction<PayloadData<Error, StopUserStatesBulkUpdate$Request, true>>('USER_STATE_BULK_UPDATE__STOP_USER_STATES_BULK_UPDATE__FAILURE');

export const stopUserStatesBulkUpdateActions = [
    stopUserStatesBulkUpdateRequest,
    stopUserStatesBulkUpdateSuccess,
    stopUserStatesBulkUpdateFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopUserStatesBulkUpdate = (meta: StopUserStatesBulkUpdate$Request, config?: StopUserStatesBulkUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopUserStatesBulkUpdateActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/states`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UserStateBulkUpdate$Request {
    updateUserState: UpdateUserState;
    reason?: string;
}

export interface UserStateBulkUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userStateBulkUpdateRequest = createAction<PayloadData<void, UserStateBulkUpdate$Request>>('USER_STATE_BULK_UPDATE__USER_STATE_BULK_UPDATE__REQUEST');
export const userStateBulkUpdateSuccess = createAction<PayloadData<string, UserStateBulkUpdate$Request>>('USER_STATE_BULK_UPDATE__USER_STATE_BULK_UPDATE__SUCCESS');
export const userStateBulkUpdateFailure = createAction<PayloadData<Error, UserStateBulkUpdate$Request, true>>('USER_STATE_BULK_UPDATE__USER_STATE_BULK_UPDATE__FAILURE');

export const userStateBulkUpdateActions = [
    userStateBulkUpdateRequest,
    userStateBulkUpdateSuccess,
    userStateBulkUpdateFailure
] as const;

/**
 * @param {UpdateUserState} meta.updateUserState
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userStateBulkUpdate = (meta: UserStateBulkUpdate$Request, config?: UserStateBulkUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: userStateBulkUpdateActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/states`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateUserState,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

